import { i18n } from 'next-i18next';

export function openURL(url, target) {
  const locale = i18n.language;
  if (locale === 'ja') {
    window.open(url, target);
  } else {
    window.open(`/${locale}${url}`, target);
  }
}
